import { z } from 'zod'
import { oc } from '@orpc/contract'
import { TASK_RUN_ACTION_VALUES, TASK_RUN_STATUS_VALUES } from './tasks-shared.contract'

/**
 * Admin action on a run; `action` defaults to 'cancel'. cancel: pending/paused → cancelled
 * immediately, started → cancel (the runner winds down and the framework finalizes to
 * cancelled). pause: pending → paused (a started run can only be cancelled). resume:
 * paused → pending. Runs already past the transition are idempotent; anything else → 409.
 * `slug` must match the run's task, else 404.
 */
export const taskRunAction = oc
  .route({ method: 'POST', path: '/v2/tasks/{slug}/runs/{id}' })
  .input(
    z.object({
      slug: z.string().min(1),
      id: z.coerce.number().int().positive(),
      action: z.enum(TASK_RUN_ACTION_VALUES).default('cancel'),
    }),
  )
  .output(z.object({ id: z.number(), status: z.enum(TASK_RUN_STATUS_VALUES) }))
